<template>
  <section class="monitor-health mb-2">
    <div class="d-flex align-items-center justify-content-between mb-1">
      <h2 class="h4 mb-0">
        {{ $t('Saúde do pipeline (agora)') }}
      </h2>
      <small class="text-muted">
        {{ $t('Ignora o período; respeita o filtro de lojas. As filas são globais.') }}
      </small>
    </div>

    <div class="monitor-health__grid">
      <button
        v-for="item in alertItems"
        :id="`auto-delivery-monitor_alert-${item.alert}`"
        :key="item.alert"
        type="button"
        class="monitor-health__card"
        :class="{
          'monitor-health__card--alert': item.count > 0,
          'monitor-health__card--selected': selectedAlert === item.alert,
        }"
        :disabled="!item.count"
        :title="item.hint"
        @click="$emit('select', selectedAlert === item.alert ? null : item.alert)"
      >
        <span class="monitor-health__count">{{ item.count }}</span>
        <span class="monitor-health__label">{{ item.text }}</span>
        <small
          v-if="item.lastErrorCode"
          class="monitor-health__error"
        >
          {{ item.lastErrorCode }}
        </small>
        <small
          v-else-if="!item.count"
          class="text-success"
        >
          {{ $t('ok') }}
        </small>
      </button>

      <div
        v-for="queue in queueItems"
        :key="queue.key"
        class="monitor-health__card monitor-health__card--queue"
        :class="{ 'monitor-health__card--alert': queue.alert }"
      >
        <span class="monitor-health__count">{{ queue.value }}</span>
        <span class="monitor-health__label">{{ queue.text }}</span>
        <small :class="queue.alert ? 'monitor-health__error' : 'text-muted'">{{ queue.detail }}</small>
      </div>
    </div>
  </section>
</template>

<script>
import { alertLabels } from '../monitor-labels'

export default {
  name: 'MonitorHealth',

  props: {
    health: {
      type: Object,
      default: null,
    },
    selectedAlert: {
      type: String,
      default: null,
    },
  },

  computed: {
    alertItems() {
      const alerts = this.health?.alerts || []
      return Object.entries(alertLabels).map(([alert, meta]) => {
        const found = alerts.find(item => item.alert === alert)
        return {
          alert,
          text: this.$t(meta.text),
          hint: this.$t(meta.hint),
          count: found?.count || 0,
          lastErrorCode: found?.lastErrorCode || null,
        }
      })
    },
    queueItems() {
      return [
        this.queueItem('queue', this.$t('Fila principal (SQS)'), this.health?.queue, false),
        this.queueItem('dlq', this.$t('DLQ (SQS)'), this.health?.deadLetterQueue, true),
      ]
    },
  },

  methods: {
    queueItem(key, text, queue, isDeadLetter) {
      if (!queue?.configured) {
        return { key, text, value: '-', detail: this.$t('Fila não configurada'), alert: false }
      }
      if (queue.error) {
        return { key, text, value: '?', detail: this.$t(queue.error), alert: true }
      }
      // Qualquer mensagem na DLQ exige atenção; na fila principal, o acúmulo é que importa.
      return {
        key,
        text,
        value: queue.visible,
        detail: `${queue.inFlight} ${this.$t('em processamento')} · ${queue.delayed} ${this.$t('atrasadas')}`,
        alert: isDeadLetter ? queue.visible > 0 : false,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.monitor-health {
  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    gap: 0.75rem;
  }

  &__card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0.75rem 1rem;
    border: 1px solid #d8dbe0;
    border-left: 5px solid var(--success);
    border-radius: 0.5rem;
    background: white;
    text-align: left;

    &:disabled {
      cursor: default;
    }

    &--alert {
      border-left-color: var(--danger);
    }

    &--queue {
      border-left-color: var(--info);

      &.monitor-health__card--alert {
        border-left-color: var(--danger);
      }
    }

    &--selected {
      box-shadow: 0 0 0 2px var(--primary);
    }
  }

  &__count {
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 1.2;
  }

  &__label {
    font-weight: 500;
  }

  &__error {
    color: var(--danger);
    word-break: break-all;
  }
}
</style>
